var _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgRoom = function SvgRoom(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#494949"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.73 31c0 .552.553 1 0 1H6a1 1 0 0 1-.863-1.504l9.929-17a1 1 0 0 1 .863-.496h14.547a1 1 0 0 1 .872.511l9.524 17A1 1 0 0 1 40 32H28.378c-.552 0 0-.448 0-1H40l-9.524-17H15.929L6 31h11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 31h-11a.5.5 0 1 0 0 1h11a.5.5 0 1 0 0-1ZM37.5 32v11.05a.5.5 0 1 0 1 0V32a.5.5 0 1 0-1 0ZM6.5 32v11.05a.5.5 0 1 0 1 0V32a.5.5 0 1 0-1 0ZM5.69 20.743h5.439a1 1 0 0 0 .852-.477l2.669-4.354a1 1 0 0 0-.853-1.522H10V8a1 1 0 0 0-1.574-.82L4.725 9.774a1 1 0 0 0-.427.819v5.91c0 .553 1 0 1 0v-5.91L9 8v7.39h4.797l-2.668 4.353h-5.44s-.552 1 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.572 23.39a1 1 0 0 1 .875 1.485l-2.42 4.354a1 1 0 0 1-.873.514H1.298a1 1 0 0 1-1-1v-9.151a1 1 0 0 1 .427-.82l3.701-2.591A1 1 0 0 1 6 17v6.39h2.572ZM5 17l-3.702 2.592v9.151h4.856l2.418-4.353H5V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 29.5v4.123a.5.5 0 1 0 1 0V29.5a.5.5 0 1 0-1 0ZM41.287 19.743a1 1 0 0 1-1 1h-5.302a1 1 0 0 1-.886-.535l-2.283-4.354a1 1 0 0 1 .886-1.464h3.411V8a1 1 0 0 1 1.574-.82l3.702 2.593a1 1 0 0 1 .426.819v5.454a1 1 0 0 1-1.141.99l.141-.99v-5.454L37.113 8v7.39h-4.642l2.514 4.353h5.302l.141-.99a1 1 0 0 1 .859.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.274 17v7.39h-3.572l2.419 4.353h4.855v-9.151L41.274 17Zm-1 0a1 1 0 0 1 1.574-.82l3.702 2.593a1 1 0 0 1 .426.819v9.151a1 1 0 0 1-1 1h-4.855a1 1 0 0 1-.874-.514l-2.42-4.354a1 1 0 0 1 .875-1.485h2.572V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 29.5v4.123a.5.5 0 1 0 1 0V29.5a.5.5 0 1 0-1 0ZM15.5 8.5h15v-7h-15v7Zm-.5-8h16a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H15a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 .5-.5Z"
  }))));
};

export { SvgRoom as ReactComponent };
export default "/_next/static/media/room.9a1195b0.svg";